import { render, staticRenderFns } from "./InviteUserModal.vue?vue&type=template&id=779b2908&lang=pug"
import script from "./InviteUserModal.vue?vue&type=script&lang=js"
export * from "./InviteUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports